import Vue from 'vue';
import Vuex from 'vuex';
import storage from './sdk/common/Storage';
import { FrontE } from '@/sdk/common/SysConst';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    isMobile: false,
    lang: storage.get('locale') || FrontE.defaultLang,
    orgPath: '', // 重定向前路由
    headerMenus: [],
    footerMenus: [],
    isShowMenu: false
  },
  mutations: {
    setIsMobile (state, is) {
      state.isMobile = is;
    },
    setLang (state, lang) {
      state.lang = lang;
    },
    setOrgPath (state, path) {
      state.orgPath = path;
    },
    setHeaderMenus (state, menu) {
      state.headerMenus = menu;
    },
    setFooterMenus (state, menu) {
      state.footerMenus = menu;
    },
    isShowMenu (state, isShowMenu) {
      state.isShowMenu = isShowMenu;
    }
  },
  actions: {
    setIsMobile: ({ commit }, is) => {
      commit('setIsMobile', is);
    },
    setLang (context, lang) {
      context.commit('setLang', lang);
    },
    setOrgPath: ({ commit }, path) => {
      commit('setOrgPath', path);
    },
    setHeaderMenus: ({ commit }, menu) => {
      commit('setHeaderMenus', menu);
    },
    setFooterMenus: ({ commit }, menu) => {
      commit('setFooterMenus', menu);
    },
    isShowMenu: ({ commit }, isShowMenu) => {
      commit('isShowMenu', isShowMenu);
    }
  }
});
